export const REDUCER_NAME='paymentGatewaySlice'

export interface iPaymentGatewayDTO {
    title?: string;
    apiKey?: string | null;
    secretKey?: string | null;
    mode?: string | null;      
    image?: string | null|File;
    companyName?: string;
    status?:boolean | number | string;
    oauthAccountId?: string | null;
    oauthConnectedAt?: string | null;
    oauthTokenExpiresAt?: string | null;
    oauthPublicToken?: string | null;
}

export interface iPaymentGatewayState {
    isLoading: boolean; 
    paymentGatewayList: iPaymentGatewayDTO[]; 
    errorMessage: string | null; 
  }
  
